import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Front'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/one-page',
    name: 'onePage',
    component: () => import("@/views/pages/LandingPage/index"),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../views/pages/NotFound/index'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/403',
    name: '403',
    component: () => import('../views/pages/Forbidden/index'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/redirect',
    name: 'redirect',
    component: () => import('../views/pages/redirect'),
    meta: {
      requiresAuth: false
    }
  },
  /*{
    path: '/webview/notification/:id',
    name: 'redirect',
    component: () => import('../views/pages/Webview/Notification')
  },*/
  {
    path: '/auth',
    name: 'auth',
    component: () => import('../views/auth/AuthLayout'),
    children: [
      {
        path: '/',
        redirect: "/auth/login",
        component: () => import('../views/auth/Login'),
        meta: {
          requiresAuth: false
        },
      },
      {
        path: '/auth/login',
        name: 'login',
        component: () => import('../views/auth/Login'),
        meta: {
          requiresAuth: false
        },
      },
      {
        path: '/auth/change-password',
        name: 'changePassword',
        component: () => import('../views/auth/changePassword')
      }
    ]
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/admin/AdminLayout'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'list-users',
        name: 'user',
        component: () => import('../views/admin/user'),
        default: true,
        meta: {
          model: 'users',
          requiresAuth: true,
        }
      },
      {
        path: 'list-users/add',
        name: 'addUser',
        component: () => import('../views/admin/user/function'),
        meta: {
          model: 'users',
          requiresAuth: true,
        }
      },
      {
        path: 'list-users/edit/:id',
        name: 'editUser',
        component: () => import('../views/admin/user/function'),
        meta: {
          model: 'users',
          requiresAuth: true,
        }
      },
      {
        path: 'list-users/view/:id',
        name: 'viewUser',
        component: () => import('../views/admin/user/view'),
        meta: {
          model: 'users',
          requiresAuth: true,
        }
      },
      // {
      //   path: 'list-category-url',
      //   name: 'category_url',
      //   component: () => import('../views/admin/category_url'),
      //   default: true,
      //   meta: {
      //     model: 'category_url',
      //     requiresAuth: true,
      //   }
      // },
      // {
      //   path: 'list-category-url/edit/:id',
      //   name: 'editCategoryUrl',
      //   component: () => import('../views/admin/category_url/function'),
      //   meta: {
      //     model: 'category_url',
      //     requiresAuth: true,
      //   }
      // },
      // {
      //   path: 'list-url',
      //   name: 'urls',
      //   component: () => import('../views/admin/urls'),
      //   default: true,
      //   meta: {
      //     model: 'urls',
      //     requiresAuth: true,
      //   }
      // },
      // {
      //   path: 'list-url/edit/:id',
      //   name: 'editCategoryUrl',
      //   component: () => import('../views/admin/urls/function'),
      //   meta: {
      //     model: 'urls',
      //     requiresAuth: true,
      //   }
      // },
      // {
      //   path: 'list-history-point',
      //   name: 'history_point',
      //   component: () => import('../views/admin/history_point'),
      //   default: true,
      //   meta: {
      //     model: 'history_point',
      //     requiresAuth: true,
      //   }
      // },
      {
        path: 'list-admin',
        name: 'admin',
        component: () => import('../views/admin/admin'),
        default: true,
        meta: {
          model: 'view_admin',
          requiresAuth: true,
        }
      },
      {
        path: 'list-admin/add',
        name: 'addAdmin',
        component: () => import('../views/admin/admin/function'),
        meta: {
          model: 'view_admin',
          requiresAuth: true,
        }
      },
      {
        path: 'list-admin/edit/:id',
        name: 'editAdmin',
        component: () => import('../views/admin/admin/function'),
        meta: {
          model: 'view_admin',
          requiresAuth: true,
        }
      },
      {
        path: 'list-post',
        name: 'post',
        component: () => import('../views/admin/post'),
        default: true,
        meta: {
          model: 'post',
          requiresAuth: true,
        }
      },
      {
        path: 'list-post/add',
        name: 'addPost',
        component: () => import('../views/admin/post/function'),
        meta: {
          model: 'post',
          requiresAuth: true,
        }
      },
      {
        path: 'list-post/edit/:id',
        name: 'editPost',
        component: () => import('../views/admin/post/function'),
        meta: {
          model: 'post',
          requiresAuth: true,
        }
      },
      {
        path: 'list-policy',
        name: 'policy',
        component: () => import('../views/admin/policy'),
        meta: {
          model: 'policy',
          requiresAuth: true
        }
      },
      {
        path: 'list-policy/edit/:id',
        name: 'editPolicy',
        component: () => import('../views/admin/policy/function'),
        meta: {
          model: 'policy',
          requiresAuth: true
        }
      },
      {
        path: 'list-guide',
        name: 'guide',
        component: () => import('../views/admin/guide'),
        meta: {
          model: 'guide',
          requiresAuth: true
        }
      },
      {
        path: 'list-guide/add',
        name: 'addGuide',
        component: () => import('../views/admin/guide/function'),
        meta: {
          model: 'guide',
          requiresAuth: true
        }
      },
      {
        path: 'list-guide/edit/:id',
        name: 'editGuide',
        component: () => import('../views/admin/guide/function'),
        meta: {
          model: 'guide',
          requiresAuth: true
        }
      },
      {
        path: 'list-reason',
        name: 'report_reason',
        component: () => import('../views/admin/reason'),
        meta: {
          model: 'report_reason',
          requiresAuth: true
        }
      },
      {
        path: 'list-report_reason/add',
        name: 'addReport_reason',
        component: () => import('../views/admin/reason/function'),
        meta: {
          model: 'report_reason',
          requiresAuth: true
        }
      },
      {
        path: 'list-report_reason/edit/:id',
        name: 'editReport_reason',
        component: () => import('../views/admin/reason/function'),
        meta: {
          model: 'report_reason',
          requiresAuth: true
        }
      },
      {
        path: 'list-banner',
        name: 'banner',
        component: () => import('../views/admin/banner'),
        meta: {
          model: 'banner',
          requiresAuth: true
        }
      },
      {
        path: 'list-banner/add',
        name: 'addBanner',
        component: () => import('../views/admin/banner/function'),
        meta: {
          model: 'banner',
          requiresAuth: true
        }
      },
      {
        path: 'list-banner/edit/:id',
        name: 'editBanner',
        component: () => import('../views/admin/banner/function'),
        meta: {
          model: 'banner',
          requiresAuth: true
        }
      },
      {
        path: 'list-report-user',
        name: 'report_user',
        component: () => import('../views/admin/report_user'),
        meta: {
          model: 'report_user',
          requiresAuth: true
        }
      },
      {
        path: 'list-report-post',
        name: 'report_post',
        component: () => import('../views/admin/report_post'),
        meta: {
          model: 'report_post',
          requiresAuth: true
        }
      },
      {
        path: 'list-report-post/view/:id',
        name: 'viewReport_post',
        component: () => import('../views/admin/report_post/view_post.vue'),
        meta: {
          model: 'report_post',
          requiresAuth: true,
        }
      },
      {
        path: 'list-notification',
        name: 'notification',
        component: () => import('../views/admin/notification'),
        default: true,
        meta: {
          model: 'notification',
          requiresAuth: true,
        }
      },
      {
        path: 'list-notification/add',
        name: 'addNotification',
        component: () => import('../views/admin/notification/function'),
        meta: {
          model: 'notification',
          requiresAuth: true
        }
      },
      {
        path: 'list-notification/edit/:id',
        name: 'editNotification',
        component: () => import('../views/admin/notification/function'),
        meta: {
          model: 'notification',
          requiresAuth: true
        }
      },
      
      
      {
        path: 'list-group',
        name: 'group',
        component: () => import('../views/admin/permission'),
        default: true,
        meta: {
          model: 'group',
          requiresAuth: true,
        }
      },
      {
        path: 'list-group/add',
        name: 'addGroup',
        component: () => import('../views/admin/permission/function'),
        meta: {
          model: 'group',
          requiresAuth: true,
        }
      },
      {
        path: 'list-group/edit/:id',
        name: 'editGroup',
        component: () => import('../views/admin/permission/function'),
        meta: {
          model: 'group',
          requiresAuth: true,
        }
      },
      
      {
        path: 'list-state',
        name: 'state',
        component: () => import('../views/admin/state'),
        default: true,
        meta: {
          model: 'state',
          requiresAuth: true,
        }
      },
      {
        path: 'list-state/edit/:id',
        name: 'editState',
        component: () => import('../views/admin/state/function'),
        meta: {
          model: 'state',
          requiresAuth: true,
        }
      },
      {
        path: 'list-clubs',
        name: 'clubs',
        component: () => import('../views/admin/clubs'),
        meta: {
          model: 'clubs',
          requiresAuth: true,
        }
      },
      {
        path: 'list-clubs/edit/:id',
        name: 'editClubs',
        component: () => import('../views/admin/clubs/function'),
        meta: {
          model: 'clubs',
          requiresAuth: true,
        }
      },
      {
        path: 'list-club-member/:id',
        name: 'clubs_member',
        component: () => import('../views/admin/clubs/clubs_members'),
        meta: {
          model: 'clubs_member',
          requiresAuth: true,
        }
      },
      {
        path: 'list-clubs/:id/join',
        name: 'join',
        component: () => import('../views/admin/clubs/join'),
        meta: {
          model: 'join',
          requiresAuth: true,
        }
      },
      {
        path: 'list-match',
        name: 'match',
        component: () => import('../views/admin/match'),
        meta: {
          model: 'match',
          requiresAuth: true,
        }
      },
      {
        path: 'list-match/edit/:id',
        name: 'editMatch',
        component: () => import('../views/admin/match/function.vue'),
        meta: {
          model: 'match',
          requiresAuth: true,
        }
      },
      {
        path: 'list-match-member/:id',
        name: 'match_member',
        component: () => import('../views/admin/match/match_members'),
        meta: {
          model: 'match_member',
          requiresAuth: true,
        }
      },
      {
        path: 'list-stadium',
        name: 'stadium',
        component: () => import('../views/admin/stadium'),
        default: true,
        meta: {
          model: 'stadium',
          requiresAuth: true,
        }
      },
      {
        path: 'list-stadium/add',
        name: 'addStadium',
        component: () => import('../views/admin/stadium/function'),
        meta: {
          model: 'stadium',
          requiresAuth: true,
        }
      },
      {
        path: 'list-stadium/edit/:id',
        name: 'editStadium',
        component: () => import('../views/admin/stadium/function'),
        meta: {
          model: 'stadium',
          requiresAuth: true,
        }
      },
    ]
  }
]

const router = new VueRouter({
  routes,
  mode: 'history',
  //base: process.env.BASE_URL,
})


export default router